import type { AssetResultMatch } from '../types';

/**
 * Maps GraphQL match `__typename` values to the tracking plan `match_type` values.
 *
 * This keeps UI components free of analytics-specific strings; callers can pass
 * the raw match typename and translate it at the tracking boundary.
 */
export const MatchTypeTrackingMap: Partial<
  Record<NonNullable<AssetResultMatch['__typename']>, string>
> = {
  AssigneeMatch: 'Assignee',
  AudioSampleRateMatch: 'AudioSampleRate',
  BitDepthMatch: 'BitDepth',
  BitRateMatch: 'BitRate',
  ChannelsMatch: 'Channels',
  CodecMatch: 'Codec',
  ColorSpaceMatch: 'ColorSpace',
  CommentCountMatch: 'CommentCount',
  CommentMatch: 'Comment',
  CreatorMatch: 'Creator',
  DeletedAtMatch: 'DeletedAt',
  DurationMatch: 'Duration',
  DynamicRangeMatch: 'DynamicRange',
  FileTypeMatch: 'FileType',
  FilesizeMatch: 'FileSize',
  FormatMatch: 'Format',
  FrameRateMatch: 'FrameRate',
  HasAlphaChannelMatch: 'HasAlphaChannel',
  InsertedAtMatch: 'InsertedAt',
  KeywordsMatch: 'Keywords',
  NameMatch: 'Name',
  NotesMatch: 'Notes',
  PageCountMatch: 'PageCount',
  ProjectMatch: 'Project',
  RatingMatch: 'Rating',
  ResolutionHeightMatch: 'ResolutionHeight',
  ResolutionWidthMatch: 'ResolutionWidth',
  SourceFilenameMatch: 'SourceFilename',
  StatusMatch: 'Status',
  TranscriptMatch: 'Transcription',
  TranscriptionMatch: 'Transcription',
  TranscriptionResultMatch: 'Transcription',
  UpdatedAtMatch: 'UpdatedAt',
  UploadedAtMatch: 'UploadedAt',
  VisualMatch: 'Visual',
} as const;

export type MatchTypeTrackingValue =
  (typeof MatchTypeTrackingMap)[keyof typeof MatchTypeTrackingMap];
